/**
 * en-GB messages added by Phase 4 task L4 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const l4EnGB = {};
//# sourceMappingURL=l4.js.map